import { lazy } from 'react';
import Loadable, { LoadingSpinner as Loading } from '@comeon/loadable';

export const AsyncPendingWithdrawals = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "payment" */
			'./pendingwithdrawals'
		),
	loading: Loading
});

export const Wallet = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "payment" */
			'./wallet/index.js'
		),
	loading: Loading
});

export const Withdraw = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "payment" */
			'./withdraw'
		),
	loading: Loading
});

export const PaymentResult = lazy(
	() =>
		import(
			/* webpackChunkName: "payment" */
			'./payment-result/payment-result.js'
		)
);

export const RegDepositResultBeta = lazy(
	() =>
		import(
			/* webpackChunkName: "payment" */
			'./payment-result/deposit-result-registration.js'
		)
);

export const AccountAutoWithdrawalsPopupContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "payment" */
			'./auto-withdrawals/account-auto-withdrawals-container.js'
		),
	loading: Loading
});

export const WithdrawTempAccountVerifyPopup = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "payment" */
			'./temporary-account/withdraw-temp-account-verify-popup.js'
		),
	loading: Loading
});
